import { useMemo } from "react";
import { ISeriesListItem } from "@/models/seriesListItem";

export const useLocalState = (item: ISeriesListItem) => {
  const showTopRightBadge = useMemo(
    () => item.isSensitive || item.isCompleted || item.isOneshot,
    [item.isCompleted, item.isOneshot, item.isSensitive],
  );

  const topRightBadgeText = useMemo(() => {
    if (item.isSensitive) return "センシティブ";
    if (item.isOneshot) return "読切";
    if (item.isCompleted) return "完結";
    return;
  }, [item.isCompleted, item.isOneshot, item.isSensitive]);

  return {
    showTopRightBadge,
    topRightBadgeText,
  };
};
